import styles from './faults_grid.module.scss';
import {useState} from 'react';
import {FaultModal} from './fault_modal.tsx';
import {FailureIndicatorType} from '../../gql/pwa/graphql.ts';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    indicator: FailureIndicatorType | null;
}

export function FaultsGridItem({indicator}: OwnProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (indicator && indicator.image_url) {
        return (
            <div
                className={classNames(styles.faults_grid__item, {
                    [styles.open]: isModalOpen,
                })}
                onClick={() => setIsModalOpen(true)}
            >
                <div className={styles.item__image}>
                    <img src={indicator.image_url} alt={''} onError={(e) => (e.currentTarget.style.display = 'none')} />
                </div>

                {isModalOpen && <FaultModal onCloseModal={() => setIsModalOpen(false)} indicator={indicator} />}
            </div>
        );
    } else {
        return null;
    }
}
